import Image from 'next/image';
import { FC } from 'react';

interface Props {
  topic: string;
  detail: string;
  backgroundImage?: string;
}

const PageHeader: FC<Props> = ({ topic, detail, backgroundImage }) => {
  return (
    <div className="relative w-screen h-fit lg:h-[27rem] bg-darkBlue flex justify-center items-center">
      {backgroundImage && (
        <div className="absolute top-0 left-0 inset-0 z-0">
          <Image
            src={backgroundImage}
            alt="background-image-header"
            width="100%"
            height="100%"
            layout="fill"
            objectFit="cover"
          />
        </div>
      )}

      <section id={topic} className="Container relative z-10 mt-20 lg:mt-8 mb-16 lg:mb-0">
        <h1 className="gradient-head-large w-fit text-dSmallBold leading-[5rem]">
          {topic}
        </h1>
        <p className="text-white text-p1Medium mt-5">{detail}</p>
      </section>
    </div>
  );
};

export default PageHeader;
